import { TextSkeleton, GridSkeleton, TabPanelSkeleton } from "@/components/Skeletons";

export function SarSkeleton() {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <TextSkeleton />
        <GridSkeleton columns={4} rows={2} className="max-w-[50%]" />
      </div>
      <div />
      <div className="flex justify-between">
        <TabPanelSkeleton height={2} width={5} />
        <div className="flex items-center gap-6">
          <TextSkeleton width={15} />
          <TextSkeleton width={9.25} height={2.5} />
        </div>
      </div>
    </div>
  );
}
